import { useTranslation } from 'react-i18next';

function SuspenseContent() {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-center w-full h-[80vh] text-gray-400 bg-base-100">
      <div className="flex flex-col items-center gap-4">
        <span className="loading loading-spinner loading-lg text-primary"></span>
        <p className="text-lg font-semibold">{t('LOADING')}</p>
      </div>
    </div>
  );
}

export default SuspenseContent;
